import React, { useState, useEffect } from "react";
import axios from "axios";
import { parseISO, format } from "date-fns";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import BlockUi from "react-block-ui";

const ResponsiveModal = styled(Modal)`
  .modal-body {
    padding: 40px !important;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .modal-content {
    border-radius: 10px !important;
    max-height: 90vh;
  }

  .modal-dialog {
    max-width: 700px !important;
  }

  @media screen and (max-width: 767px) {
    .modal-content {
      width: 90% !important;
      margin: 0 auto !important;
    }
  }
`;

const ButtonBack = styled.img`
  filter: brightness(0) saturate(100%) invert(58%) sepia(59%) saturate(452%)
    hue-rotate(103deg) brightness(92%) contrast(83%);
  cursor: pointer;
  margin: 0 5px 5px 0;
`;

export function ClientesCancelados(props) {
  const [modalLogsOpen, setModalLogsOpen] = useState(false);
  const [logs, setLogs] = useState({});
  const [data, setData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [page, setPage] = useState(0);
  const itemsPerPage = 50;
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getConsultas = async () => {
    setIsLoading(true);

    let endpoint;
    if (props.match.params.tipo === "clientes")
      endpoint = "/dashboard/lost_clients";
    if (props.match.params.tipo === "recente")
      endpoint = "/dashboard/lost_recent_clients";
    const response = await axios.post(
      process.env.REACT_APP_API_URL + endpoint,
      {
        item_offset: itemOffset,
        items_per_page: itemsPerPage
      }
    );
    setData(response.data.canceled);
    setTotal(response.data.total);

    setPageCount(Math.ceil(response.data.total / itemsPerPage));
    setIsLoading(false);
  };

  useEffect(() => {
    getConsultas();
  }, [itemOffset]);

  useEffect(() => {
    getConsultas();
  }, []);

  const handlePageClick = event => {
    setPage(event.selected);
    const newOffset = (event.selected * itemsPerPage) % total;
    setItemOffset(newOffset);
  };

  const whatsapp = phone => {
    const phoneOnlyNumbers = phone
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "");
    const phoneInternational = `55${phoneOnlyNumbers}`;

    window.open(
      `https://api.whatsapp.com/send?phone=${phoneInternational}&text=`,
      "_blank"
    );
  };

  return (
    <>
      <ResponsiveModal
        show={modalLogsOpen}
        onHide={() => setModalLogsOpen(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <ButtonBack
            onClick={() => setModalLogsOpen(false)}
            src={toAbsoluteUrl("/media/svg/icons/Navigation/Arrow-left.svg")}
          />
          <h3>Response:</h3>
          {logs && logs.query_response && (
            <div>
              <pre>{JSON.stringify(logs.query_response, null, 2)}</pre>
            </div>
          )}
          <h3>Plain:</h3>
          {logs && logs.query_response_plain && (
            <div>
              <pre>{JSON.stringify(logs.query_response_plain, null, 2)}</pre>
            </div>
          )}
        </Modal.Body>
      </ResponsiveModal>

      <h1 className="azul-cabecalho">RELATÓRIO</h1>
      <p className="subheader-text mb-10">clientes cancelados</p>
      <BlockUi tag="div" blocking={isLoading}>
        <div className="row mb-10">
          <div className="col-xl-12">
            <div
              style={{
                backgroundColor: "#fff",
                border: "1px solid #eaeaea",
                borderRadius: "5px",
                padding: "20px"
              }}
            >
              <div className="row mb-5">
                <h3>Clientes cancelados</h3>
                <table className="table table-bordered table-striped table-sm">
                  <thead className="light">
                    <tr>
                      <th>Cancelado em</th>
                      <th>Qtd. Pagamentos</th>
                      <th>Cliente</th>
                      <th>E-mail</th>
                      <th>Telefone</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map(query => (
                        <tr>
                          <td>
                            {format(
                              parseISO(query.canceled_at),
                              "dd/MM/yyyy HH:mm"
                            )}
                          </td>
                          <td>{query.qtd_pagas}</td>
                          <td>{query.name}</td>
                          <td>{query.email}</td>
                          <td>
                            <a
                              href="javascript:;"
                              onClick={() => whatsapp(query.phone)}
                            >
                              {query.phone}
                            </a>
                          </td>
                          <td>
                            <Link target="_BLANK" to={`/clientes/${query.id}`}>
                              <button
                                type="button"
                                className="btn btn-icon btn-primary"
                              >
                                <i className="flaticon-eye"></i>
                              </button>
                            </Link>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="row justify-content-center">
                  <ReactPaginate
                    nextLabel="próximo >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    forcePage={page}
                    marginPagesDisplayed={1}
                    previousLabel="< anterior"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlockUi>
    </>
  );
}
